import React, { useState, useRef, useMemo } from 'react';
import moment from "moment";

const ShowLearnerPreScheduledClassesPopup = ({setShowLearnerPreSchedulePopup, StudentAllCoursesSchedule}) => {
    const handleCancelPopupClick = () =>{
        setShowLearnerPreSchedulePopup(false)
      }

    
  // 💡 Process and group future events by date
  const groupedSchedule = useMemo(() => {
    const grouped = {};
    const now = moment(); // current time
  
    StudentAllCoursesSchedule
      .filter(event => moment(event.startDate).isSameOrAfter(now, 'day')) // keep only future or today
      .forEach(event => {
        const eventDate = moment(event.startDate).format("DD-MM-YYYY");
  
        if (!grouped[eventDate]) grouped[eventDate] = [];
  
        const timeSlot = `${moment(event.startDate).format("hh:mm A")} - ${moment(event.endDate).format("hh:mm A")}`;
        grouped[eventDate].push(timeSlot);
      });
  
    return grouped;
  }, [StudentAllCoursesSchedule]);
  
  return (
  <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[20px] pt-[20px] shadow-lg w-[350px]"> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>

            <div className="flex flex-col gap-[15px]">
                <div className="flex justify-between ">
                    <p className="text-[16px] text-[#696974] font-semibold">Learner Pre-Scheduled Classes</p>
                </div>

                <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                {Object.entries(groupedSchedule).map(([date, times]) => (
                    <div key={date} className="flex items-start gap-[10px]">
                        <div className="w-[100px] text-[16px] font-medium shrink-0">{date}</div>
                        <div className="flex items-start gap-[10px] flex-wrap">
                        {times.map((time, index) => (
                            <div key={index} className="flex items-center gap-[5px] text-[16px] text-[#3A3A3A] ">
                            <span className="material-symbols-outlined text-[#A1A3EF] text-[18px]">radio_button_checked</span>
                            <span>{time}</span>
                            </div>
                        ))}
                        </div>
                    </div>
                ))}
                </div> 
            </div>
          
  </div>
  );
};

export default ShowLearnerPreScheduledClassesPopup;

